import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Marquee } from "./components/Marquee";
import { Journey } from "./components/Journey";
import { NextAssessment } from "./components/NextAssessment";
import { Destinations } from "./components/Destinations";
import { WhyUs } from "./components/WhyUs";
import { Team } from "./components/Team";
import { Testimonials } from "./components/Testimonials";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    const handleModalState = (event) => {
      if (event.detail) {
        lenis.stop();
      } else {
        lenis.start();
      }
    };
    window.addEventListener("movementor:modal", handleModalState);
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("movementor:modal", handleModalState);
      lenis.destroy();
    };
  }, []);

  const navigate = (hash) => {
    const el = document.querySelector(hash);
    if (el && lenisRef.current) {
      lenisRef.current.scrollTo(el, { offset: -70, duration: 1.4 });
    }
  };

  return (
    <div className="App bg-[#FFFFFF]">
      <div className="grain-overlay" />
      <Toaster position="top-center" richColors />
      <Nav onNavigate={navigate} />
      <main>
        <Hero />
        <About />
        <Marquee />
        <Journey />
        <Destinations />
        <WhyUs />
        <Team />
        <Testimonials />
        <NextAssessment />
        <Contact />
      </main>
      <Footer onNavigate={navigate} />
    </div>
  );
}

export default App;
